import CoreNewsInsightsSearch from './CoreNewsInsightsSearch';

export { type CoreNewsInsightsSearchProps } from './CoreNewsInsightsSearch';
export default CoreNewsInsightsSearch;
